import { render, staticRenderFns } from "@/modules/AccountContactRelation/templates/account-contact-relation.html?vue&type=template&id=68d69760&scoped=true&"
import script from "@/modules/AccountContactRelation/scripts/account-contact-relation.ts?vue&type=script&lang=js&"
export * from "@/modules/AccountContactRelation/scripts/account-contact-relation.ts?vue&type=script&lang=js&"
import style0 from "@/modules/AccountContactRelation/styles/account-contact-relation.scss?vue&type=style&index=0&id=68d69760&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d69760",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VImg})
